import { render, staticRenderFns } from "./LScrollBar.vue?vue&type=template&id=1dc54c66&scoped=true"
import script from "./LScrollBar.vue?vue&type=script&lang=js"
export * from "./LScrollBar.vue?vue&type=script&lang=js"
import style0 from "./LScrollBar.vue?vue&type=style&index=0&id=1dc54c66&prod&lang=scss"
import style1 from "./LScrollBar.vue?vue&type=style&index=1&id=1dc54c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc54c66",
  null
  
)

export default component.exports